import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const postInstallConfiguration = async (
  namespace: string,
  sourceId,
  body,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.post(
      `${url}/api/v1/ns/${namespace}/installation/start`,
      body,
      {
        headers: headers,
        params: {
          source_id: sourceId,
        },
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to install configuration. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while installing configuration.",
      );
    }
  }
};
